import createHasSubmitFailed from '../selectors/hasSubmitFailed';
import immutable from '../structure/immutable';

export default createHasSubmitFailed(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/hasSubmitFailed.js
// module id = 1203
// module chunks = 0